import {Component, contentChildren, input, signal, ViewEncapsulation} from '@angular/core';
import {EllipsisVerticalIcon, LucideAngularModule} from 'lucide-angular';

@Component({
  selector: 'app-responsive-buttons',
  templateUrl: './responsive-buttons.component.html',
  styleUrl: './responsive-buttons.component.scss',
  imports: [
    LucideAngularModule
  ],
  encapsulation: ViewEncapsulation.None
})
export class ResponsiveButtonsComponent {

  // // 1. Query all projected elements that contain the 'secondary' attribute
  // // ElementRef allows us to target plain HTML elements like standard buttons
  // private secondaryItems = contentChildren<any>('secondary');
  //
  // // 2. Create a reactive boolean flag to check if elements exist
  // hasSecondaryButtons = computed(() => this.secondaryItems().length > 0);

  public readonly enableSecondary = input(false);

  public readonly icons = {
    verticalEllipsis: EllipsisVerticalIcon
  };

  public readonly showSecondaryButtons = signal(false);

  public hideSecondaryButtons(): void {
    this.showSecondaryButtons.set(false);
  }

  public toggleSecondaryButtons(): void {
    this.showSecondaryButtons.update(show => !show);
  }
}
